export const personalityResult = [
    //ENTP 狐狸辩论家
    {
        type: 'ENTP',
        nickname: '狐狸辩论家',
        // 正缘
        destinedPar: {
            'INTP': '最信任',
            'ENFP': '最相似',
            'ENTP': '最搭档',
            'INFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ENTJ': '最默契',
            'ENFJ': '最有爱',
            'ISFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'INFP': '最包容',
            'ESTP': '最主动',
            'ESFP': '最话痨',
            'INTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'ISFP': '最难懂',
            'ESTJ': '最危险',
            'ESFJ': '最无语',
            'ISTP': '最冷漠'
        },
    },
    
    //ENTJ 猫猫指挥官
    {
        type: 'ENTJ',
        nickname: '猫猫指挥官',
        // 正缘
        destinedPar: {
            'INTJ': '最信任',
            'ENTP': '最相似',
            'ESFP': '最搭档',
            'ISTP': '最合拍'
        },
        // 贵人
        benefactor: {
            'INFP': '最稳健',
            'ESTP': '最默契',
            'ENFJ': '最有爱',
            'ISFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ESFJ': '最包容',
            'ESTJ': '最主动',
            'ENFP': '最话痨',
            'ENTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INFJ': '最难懂',
            'INTP': '最危险',
            'ISFP': '最无语',
            'ISTJ': '最冷漠'
        },
    },
    
    //ENFP 快乐小狗
    {
        type: 'ENFP',
        nickname: '快乐小狗',
        // 正缘
        destinedPar: {
            'ESFP': '最信任',
            'ESTP': '最相似',
            'INFJ': '最搭档',
            'INFP': '最合拍'
        },
        // 贵人
        benefactor: {
            'INTJ': '最稳健',
            'ENFP': '最默契',
            'ENFJ': '最有爱',
            'ISTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ESFJ': '最包容',
            'ENTP': '最主动',
            'ESTJ': '最话痨',
            'ENTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'ISTP': '最危险',
            'ISFJ': '最无语',
            'ISFP': '最冷漠'
        },
    },
    
    //ENFJ 领航海豚
    {
        type: 'ENFJ',
        nickname: '领航海豚',
        // 正缘
        destinedPar: {
            'INFP': '最信任',
            'ENFJ': '最相似',
            'ENTP': '最搭档',
            'ISFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ISFP': '最默契',
            'ENFP': '最有爱',
            'INFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ESFJ': '最包容',
            'ENTJ': '最主动',
            'ESFP': '最话痨',
            'ESTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'ISTP': '最难懂',
            'ESTP': '最危险',
            'INTP': '最无语',
            'INTJ': '最冷漠'
        },
    },
    
    //ESFJ 大象友友
    {
        type: 'ESFJ',
        nickname: '大象友友',
        // 正缘
        destinedPar: {
            'ENFJ': '最信任',
            'ESTJ': '最相似',
            'ISFJ': '最搭档',
            'ISTJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ESTP': '最稳健',
            'INFJ': '最默契',
            'ESFP': '最有爱',
            'ESFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ENFP': '最包容',
            'ENTJ': '最主动',
            'INFP': '最话痨',
            'INTP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTJ': '最难懂',
            'ISTP': '最危险',
            'ISFP': '最无语',
            'ENTP': '最冷漠'
        },
    },
    
    //ESFP 璀璨鹦鹉
    {
        type: 'ESFP',
        nickname: '璀璨鹦鹉',
        // 正缘
        destinedPar: {
            'ISFJ': '最信任',
            'ESTP': '最相似',
            'ENTJ': '最搭档',
            'ISTJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ESFJ': '最稳健',
            'ISFP': '最默契',
            'INFJ': '最有爱',
            'ESTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ENFJ': '最包容',
            'ENTP': '最主动',
            'ENFP': '最话痨',
            'ESFP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'ISTP': '最危险',
            'INFP': '最无语',
            'INTJ': '最冷漠'
        },
    },
    
    //ESTJ 智慧熊导师
    {
        type: 'ESTJ',
        nickname: '智慧熊导师',
        // 正缘
        destinedPar: {
            'ENFJ': '最信任',
            'ESTP': '最相似',
            'ESFJ': '最搭档',
            'INTJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ISFJ': '最默契',
            'ENTJ': '最有爱',
            'ESTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'INFJ': '最包容',
            'ENTP': '最主动',
            'ESFP': '最话痨',
            'INTP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INFP': '最难懂',
            'ENFP': '最危险',
            'ISFP': '最无语',
            'ISTP': '最冷漠'
        },
    },

    //ESTP 灵巧猴子
    {
        type: 'ESTP',
        nickname: '灵巧猴子',
        // 正缘
        destinedPar: {
            'ISFJ': '最信任',
            'ESFP': '最相似',
            'ENTJ': '最搭档',
            'ISTP': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ENFP': '最默契',
            'ENFJ': '最有爱',
            'ESTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ESTP': '最包容',
            'ENTP': '最主动',
            'ESFJ': '最话痨',
            'INTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'INFP': '最危险',
            'ISFP': '最无语',
            'INFJ': '最冷漠'
        },
    },

    //INFJ 远行驯鹿
    {
        type: 'INFJ',
        nickname: '远行驯鹿',
        // 正缘
        destinedPar: {
            'INFP': '最信任',
            'INTJ': '最相似',
            'ENTP': '最搭档',
            'ENFP': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISFJ': '最稳健',
            'ENTJ': '最默契',
            'ISTP': '最有爱',
            'ISFP': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ESFJ': '最包容',
            'ENFJ': '最主动',
            'ESFP': '最话痨',
            'INFJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'ESTP': '最危险',
            'ISTJ': '最无语',
            'ESTJ': '最冷漠'
        },
    },

    //INFP 蜜袋旅者
    {
        type: 'INFP',
        nickname: '蜜袋旅者',
        // 正缘
        destinedPar: {
            'INFJ': '最信任',
            'ISFP': '最相似',
            'ENTJ': '最搭档',
            'ENFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISFJ': '最稳健',
            'ISTJ': '最默契',
            'ENFP': '最有爱',
            'ESFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ENTP': '最包容',
            'ESFP': '最主动',
            'INFP': '最话痨',
            'ISTP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTJ': '最难懂',
            'ESTP': '最危险',
            'INTP': '最无语',
            'ESTJ': '最冷漠'
        },
    },

    //INTJ 刺猬建筑师
    {
        type: 'INTJ',
        nickname: '刺猬建筑师',
        // 正缘
        destinedPar: {
            'INFJ': '最信任',
            'INTP': '最相似',
            'ENTP': '最搭档',
            'ENTJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTP': '最稳健',
            'ENFJ': '最默契',
            'ENFP': '最有爱',
            'INTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ISFJ': '最包容',
            'ESFP': '最主动',
            'ESTP': '最话痨',
            'ESTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'ISTJ': '最难懂',
            'ESFJ': '最危险',
            'INFP': '最无语',
            'ISFP': '最冷漠'
        },
    },

    //INTP 猫头鹰魔术师
    {
        type: 'INTP',
        nickname: '猫头鹰魔术师',
        // 正缘
        destinedPar: {
            'INTJ': '最信任',
            'ENTP': '最相似',
            'INFJ': '最搭档',
            'ENFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ISTP': '最默契',
            'ISFJ': '最有爱',
            'ESTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ISFP': '最包容',
            'ENTJ': '最主动',
            'ENFP': '最话痨',
            'INTP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'ESFJ': '最难懂',
            'ESFP': '最危险',
            'INFP': '最无语',
            'ESTP': '最冷漠'
        },
    },

    //ISFJ 水豚守望者
    {
        type: 'ISFJ',
        nickname: '水豚守望者',
        // 正缘
        destinedPar: {
            'ISTJ': '最信任',
            'INTJ': '最相似',
            'ESFJ': '最搭档',
            'ENFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ESTJ': '最稳健',
            'INFP': '最默契',
            'ISFP': '最有爱',
            'ISFJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'INFJ': '最包容',
            'ESTP': '最主动',
            'ESFP': '最话痨',
            'ENTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'ENTP': '最危险',
            'ENFP': '最无语',
            'ISTP': '最冷漠'
        },
    },

    //ISFP 探险小兔
    {
        type: 'ISFP',
        nickname: '探险小兔',
        // 正缘
        destinedPar: {
            'ISFJ': '最信任',
            'ESFP': '最相似',
            'ESTP': '最搭档',
            'ENFP': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'INFP': '最默契',
            'ENFJ': '最有爱',
            'ISTP': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ISFP': '最包容',
            'ENTP': '最主动',
            'ESFJ': '最话痨',
            'ESTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTJ': '最难懂',
            'ENTJ': '最危险',
            'INTP': '最无语',
            'INFJ': '最冷漠'
        },
    },

    //ISTJ 企鹅卫士
    {
        type: 'ISTJ',
        nickname: '企鹅卫士',
        // 正缘
        destinedPar: {
            'ISFJ': '最信任',
            'ISTP': '最相似',
            'INTJ': '最搭档',
            'ESFJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ESTJ': '最稳健',
            'INFP': '最默契',
            'ISFP': '最有爱',
            'ISTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ENFJ': '最包容',
            'ESTP': '最主动',
            'ESFP': '最话痨',
            'ENTJ': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTP': '最难懂',
            'ENTP': '最危险',
            'ENFP': '最无语',
            'INFJ': '最冷漠'
        },
    },

    //ISTP 勇敢虎虎
    {
        type: 'ISTP',
        nickname: '勇敢虎虎',
        // 正缘
        destinedPar: {
            'ENFJ': '最信任',
            'ESTP': '最相似',
            'ISFJ': '最搭档',
            'ENTJ': '最合拍'
        },
        // 贵人
        benefactor: {
            'ISTJ': '最稳健',
            'ISTP': '最默契',
            'ISFP': '最有爱',
            'ESTJ': '最稳定'
        },
        // 旺你的人
        luckyCharm: {
            'ENFP': '最包容',
            'ESFP': '最主动',
            'ENTP': '最话痨',
            'INTP': '最上心'
        },
        // 孽缘
        cursedConnection: {
            'INTJ': '最难懂',
            'INFJ': '最危险',
            'INFP': '最无语',
            'ESFJ': '最冷漠'
        }
    }
]
